import { render, staticRenderFns } from "./InpatientPlan.vue?vue&type=template&id=bda4262e"
import script from "./InpatientPlan.vue?vue&type=script&lang=js"
export * from "./InpatientPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports